__turbopack_context__.v({
  "buttonContainer": "dUxxza_buttonContainer",
  "buttonDiv": "dUxxza_buttonDiv",
  "buttons": "dUxxza_buttons",
  "buttonsCell": "dUxxza_buttonsCell",
  "cancelButton": "dUxxza_cancelButton",
  "content": "dUxxza_content",
  "dialogGrid": "dUxxza_dialogGrid",
  "form": "dUxxza_form",
  "openAnimation": "dUxxza_openAnimation",
  "overlay": "dUxxza_overlay",
  "root": "dUxxza_root",
});
